/* eslint camelcase: 0 */

type IsoDate = string;

export interface Lease {
  id: string;
  display_id: string;
  expiration_at: IsoDate;
  renew_at: IsoDate;
  issued_at: IsoDate;
  warning_at: IsoDate;
  unusable_at: IsoDate;
  returned_at: IsoDate;
  platform: string;
  extended_expiration_at: IsoDate;
  unreturnable: boolean;
  may_keep_on_exit: boolean;
  is_renewed: boolean;
  requester_is_owner: boolean;
  is_expired: boolean;
  message: string;
  application_platform: string;
  agent_identifier: string;
  iat: number;
  exp: number;
  license: {
    id: string;
    display_id: string;
    display_name: string;
    license_type: string;
    license_class: string;
    cloud_expiration_date: IsoDate;
    desktop_expiration_date: IsoDate;
    multiuser: boolean;
    seats: number;
    mode: 'default' | 'ai-privacy';
    remaining_trial_days?: number;
  };
  requester: {
    id: string;
    display_id: string;
    first_name: string;
    name: string;
    has_profile: boolean;
    organization_name: string;
    is_organization: boolean;
    picture: string;
    locale: string;
    email: string;
  };
  pool: {
    id: string;
    display_id: string;
    display_name: string;
    owner: {
      id: string;
      display_id: string;
      first_name: string;
      name: string;
      has_profile: boolean;
      organization_name: string;
      is_organization: boolean;
      picture: string;
      locale: string;
      email: string;
    };
  };
}

export interface LicenseOption {
  id: string;
  display_id: string;
  display_name: string;
}

export interface MultiLicense {
  message: string;
  options: Array<LicenseOption>;
}

export enum LeaseState {
  Undefined = 'Undefined',
  Ok = 'Ok',
  NoMatchingLicense = 'NoMatchingLicense',
  NoFreeSeats = 'NoFreeSeats',
  SelfOccupiedSeat = 'SelfOccupiedSeat',
  ServerUnavailable = 'ServerUnavailable',
}

export enum LeaseResponseStatus {
  LeaseOk,
  MultiLicense,
  NoMatchingLicense,
  LicenseConflict,
  Unauthorized,
  LeaseError,
  NoAnswer,
  ServerError,
  NoAccount,
}

export interface LeaseResponse {
  status: LeaseResponseStatus;
  data?: any;
  leaseToken?: string;
}

export enum KickoutResponseStatus {
  Success,
  NoLeaseFound,
  LoginNeedsRefresh,
  NoAnswer,
  ServerError,
}

export interface GetLeaseOptions {
  /** id of license pool */
  preferred_pool_id?: string;
  /** lease time in minutes, -1 resets */
  expected_lease_time?: number;
}
